import { render } from "./add.vue?vue&type=template&id=a586d818&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=a586d818&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-a586d818"

export default script